/**
 * Capitalize the first letter of a string or sentence
 *
 * @param {string} string
 *
 * @returns string
 */
export const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1)
